import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import {
  ApplyTokenInterceptor,
  CsvLanguageInterceptor,
  RefreshTokenInterceptor,
  provideTranslate,
} from '@rp/core';
import { GlobalErrorHandler } from '@rp/shared/services';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApplyTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CsvLanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideTranslate(),
  ],
};
